// Pure, dependency-free helpers for the home hero (eyebrow + greeting).
// No imports so they stay trivially unit-testable in the node Vitest env.

export type DayPart = "morning" | "afternoon" | "evening";

/** Map a local hour (0-23) to a day-part bucket: morning <12, afternoon <18, else evening. */
export function dayPart(hour: number): DayPart {
  if (hour < 12) return "morning";
  if (hour < 18) return "afternoon";
  return "evening";
}

/** Greeting prefix for a local date, e.g. "Good morning". */
export function greeting(date: Date): string {
  return `Good ${dayPart(date.getHours())}`;
}

/** Long weekday name for a date in the user's locale, e.g. "Tuesday". */
export function weekdayLabel(date: Date): string {
  return date.toLocaleDateString(undefined, { weekday: "long" });
}

/**
 * Resolve a display first name from an optional full name, falling back to the
 * email local-part, else ''. e.g. ("Riley Adams") -> "Riley";
 * (undefined, "alastair.hardie@x") -> "Alastair".
 */
export function firstName(name?: string | null, email?: string | null): string {
  const fromName = (name ?? "").trim().split(/\s+/).filter(Boolean)[0];
  if (fromName) return fromName;
  const local = (email ?? "").split("@")[0] ?? "";
  const token = local.split(/[._-]+/).filter(Boolean)[0];
  if (!token) return "";
  return token.charAt(0).toUpperCase() + token.slice(1);
}
